"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.isOldUrl = void 0;
/* This code parses the old-format PLP URL structure from ATG/Endeca */
/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  security/detect-object-injection */
var types_1 = require("../../Types/types");
var helpers_1 = require("../helpers");
var ENDECA_PATH = 'e';
var ENDECA_FULL_PATH = '/e/';
var ENDECA_SUFFIX = '.end';
var ENDECA_VALUE_DEAL = 'v';
var ENDECA_SEARCH = 'q';
var ENDECA_BROWSE = 'b';
var ENDECA_PROMO = 'promo';
var ENDECA_FACET_REGEX = /^[0-9|,]*$/;
var PATHS_TO_IGNORE = [ENDECA_PATH, ENDECA_SEARCH, ENDECA_BROWSE, ENDECA_PROMO, ENDECA_VALUE_DEAL];
var QUERY_PARAM_MULTISELECT = 'multiselect';
var PRICE_RANGE_FACET = 'Price_Range';
var SORT_MAPPING = {
    'bestsellers,0': types_1.Sort.relevance,
    'mostrelevant,0': types_1.Sort.relevance,
    'brand,1': types_1.Sort.brand,
    'highestrated,0': types_1.Sort.highestrated,
    'newin,0': types_1.Sort.newin,
    'price,0': types_1.Sort.pricedesc,
    'price,1': types_1.Sort.price,
};
var RENAMED_FACET_VALUES = {
    'Up to £20': '"-inf"-"20"',
    '£20 to £30': '"20"-"30"',
    '£30 to £40': '"30"-"40"',
    '£40 to £50': '"40"-"50"',
    '£50 to £75': '"50"-"75"',
    '£75 to £100': '"75"-"100"',
    '£100 to £250': '"100"-"250"',
    '£250 to £500': '"250"-"500"',
    '£500 to £750': '"500"-"750"',
    '£750 to £1000': '"750"-"1000"',
    'Over £1000': '"1000"-"inf"',
};
function isOldUrl(path) {
    return path.length > 0 && path.includes(ENDECA_FULL_PATH) && path.includes(ENDECA_SUFFIX);
}
exports.isOldUrl = isOldUrl;
/* Determine the page type */
function getType(url) {
    var pathNames = url.pathname.split('/');
    var savedvalue;
    Object.entries(types_1.EndecaPageType).forEach(function (pageType) {
        var key = pageType[0], value = pageType[1];
        if (pathNames.includes(key)) {
            savedvalue = value;
        }
    });
    return savedvalue;
}
/* Converts the old sort option to the new version
   Mapping is documented at https://theverygroup.atlassian.net/wiki/spaces/REB/pages/4315349845/DCX+Discover+Squad+Sort+Orders+and+mapping
*/
function convertSort(sortOption) {
    var mappedSortOption;
    Object.entries(SORT_MAPPING).forEach(function (mappingEntry) {
        var key = mappingEntry[0], value = mappingEntry[1];
        if (key === sortOption) {
            mappedSortOption = value;
        }
    });
    return mappedSortOption;
}
function removeSuffix(text) {
    return text.endsWith(ENDECA_SUFFIX) ? text.substring(0, text.length - ENDECA_SUFFIX.length) : text;
}
/* Extracts the categories and facets from the path.
   Facets are found by looking for a path element which contains a hyphen.
   Note that if a category contains a hyphen it will be encoded as %2d */
function extractCategoriesAndFacets(url, type, pageName, endeca_mapping) {
    var _a, _b;
    var categories = [];
    var facets = [];
    var path = (_a = removeSuffix(url.pathname)) === null || _a === void 0 ? void 0 : _a.split('/');
    if ((0, helpers_1.isSearchPage)(type) || (0, helpers_1.isPromoPage)(type))
        path.pop();
    path.forEach(function (value) {
        if (!PATHS_TO_IGNORE.includes(value) && value.trim().length) {
            var facetMatch = value.match(ENDECA_FACET_REGEX);
            if (facetMatch) {
                facets.push.apply(facets, value.split(','));
            }
            else if (value !== pageName) {
                categories.push(decodeURIComponent(value));
            }
        }
    });
    // Add MultiSelect facets but avoid duplicating with the facets from the path
    var msFacets = (_b = url.searchParams.get(QUERY_PARAM_MULTISELECT)) === null || _b === void 0 ? void 0 : _b.split(',');
    msFacets === null || msFacets === void 0 ? void 0 : msFacets.forEach(function (msFacet) {
        if (!facets.includes(msFacet))
            facets.push(msFacet);
    });
    // Do Endeca mapping
    if (endeca_mapping) {
        categories = [];
        facets = facets.map(function (facetId) {
            var lookup = endeca_mapping[facetId];
            if (lookup) {
                if (lookup.breadcrumbIds) {
                    // Category
                    categories = [lookup];
                    return {};
                }
                // Facet
                return lookup;
            }
            return facetId;
        });
    }
    return { categories: categories, facets: facets };
}
function getCategories(url, type, pageName, endeca_mapping) {
    var categories = extractCategoriesAndFacets(url, type, pageName, endeca_mapping).categories;
    var results = [];
    var categoryStrings = [];
    categories.forEach(function (category) {
        if (typeof category === 'string') {
            categoryStrings.push(category.toString());
        }
        else {
            // Endeca mapping
            results.push({ id: category.id, hierarchy: category.breadcrumbIds });
        }
    });
    if (results.length) {
        return results[0]; // Endeca mapping
    }
    // Not mappend from Endeca, return as string values
    return categoryStrings.length
        ? { id: categoryStrings[categoryStrings.length - 1], hierarchy: categoryStrings }
        : undefined;
}
function getFacets(url, type, pageName, endeca_mapping) {
    var facets = extractCategoriesAndFacets(url, type, pageName, endeca_mapping).facets;
    var results = [];
    facets.forEach(function (facet) {
        var _a;
        if (typeof facet === 'string') {
            results.push({
                id: facet,
                name: '',
                values: [],
            });
        }
        else if (facet.value) {
            var facetValue = facet.value;
            // Price Range facet in Constructor doesn't use the G2/Endeca values so rename them to the constructor ones
            if (facet.facetId === PRICE_RANGE_FACET) {
                facetValue = RENAMED_FACET_VALUES[facet.value] || facet.value;
            }
            var existingFacet = results.find(function (existing) { return facet.facetId === existing.id; });
            if (existingFacet) {
                (_a = existingFacet.values) === null || _a === void 0 ? void 0 : _a.push({ id: facetValue });
            }
            else {
                results.push({
                    id: facet.facetId,
                    name: '',
                    values: [{ id: facetValue }],
                });
            }
        }
    });
    return results.length ? results : undefined;
}
function getSearchTerm(url, type) {
    if (type && (0, helpers_1.isSearchPage)(type)) {
        var path = url.pathname.split('/');
        var searchTerm = removeSuffix(path.pop() || '');
        if (searchTerm) {
            return (0, helpers_1.hyphenToSpace)(searchTerm);
        }
    }
    return undefined;
}
function getPageName(url, type) {
    var result;
    if ((0, helpers_1.hasPageName)(type)) {
        var path = url.pathname.split('/');
        if (type === types_1.PageType.promo) {
            result = removeSuffix(path.pop() || '');
        }
        else if (type === types_1.PageType.valuedeal) {
            var prevValue_1;
            path.forEach(function (value) {
                if (value === ENDECA_VALUE_DEAL) {
                    result = prevValue_1;
                }
                else if (value !== ENDECA_PATH) {
                    prevValue_1 = value;
                }
            });
        }
    }
    return result;
}
function parse(url, endeca_mapping) {
    var domain = (0, helpers_1.getDomain)(url);
    var type = getType(url);
    var sortOption = convertSort((0, helpers_1.getSort)(url));
    var pageNumber = (0, helpers_1.getPageNumber)(url);
    var numProducts = (0, helpers_1.getNumProducts)(url);
    var searchTerm = getSearchTerm(url, type);
    var pageName = getPageName(url, type);
    var category = getCategories(url, type, pageName, endeca_mapping);
    var facets = getFacets(url, type, pageName, endeca_mapping);
    return { domain: domain, type: type, category: category, facets: facets, sortOption: sortOption, pageNumber: pageNumber, numProducts: numProducts, searchTerm: searchTerm, pageName: pageName };
}
exports.parse = parse;
